import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { EMPTY_VALUE } from 'src/app/_helpers/utils';
import {
  FlowInvoiceInsight,
  getBillingDocumentTypeColor,
  getBillingDocumentTypeLabel,
  getBillingItemDocumentType,
} from 'src/app/_types/billing.types';

/**
 * Read-only counterpart of the billing list's editable type cell: a flow's
 * billing items are shown for reference, so the type is never changed here.
 *
 * Reminders resolve through the same union-aware helpers as the billing list,
 * which paint them `--warning-600` against the invoices' per-type colours.
 */
@Component({
  selector: 'app-flow-invoice-type-renderer',
  standalone: true,
  template: `<span [style.color]="color">{{ label }}</span>`,
})
export class FlowInvoiceTypeRendererComponent
  implements ICellRendererAngularComp
{
  label = EMPTY_VALUE;

  color = 'inherit';

  agInit(params: ICellRendererParams<FlowInvoiceInsight>): void {
    const type = params.data ? getBillingItemDocumentType(params.data) : null;
    if (!type) return;

    this.label = getBillingDocumentTypeLabel(type);
    this.color = getBillingDocumentTypeColor(type);
  }

  refresh(): boolean {
    return false;
  }
}
